//#region src/core/ui/input-action.ts
/** @internal */
function isInputActionIncluded(action, actions) {
	if (!action) return false;
	return !actions || actions.includes(action);
}
//#endregion
export { isInputActionIncluded };

//# sourceMappingURL=input-action.js.map